(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/coupon-settings-selector/assets/javascripts/components/coupon-settings-buttons.js') >= 0) return;  svs.modules.push('/components/tipsen/coupon-settings-selector/assets/javascripts/components/coupon-settings-buttons.js');
"use strict";

const CouponSettingsSelector = svs.components.tipsen.couponSettingsSelector.CouponSettingsSelector;
const RadioGroup = svs.ui.reactForm.RadioGroup;
const clx = svs.components.lbUtils.clx;
const CouponSettingsSelectorButtons = _ref => {
  let children = _ref.children,
    className = _ref.className;
  return React.createElement(RadioGroup, {
    className: clx('pg_coupon_settings__btns', className),
    size: "200",
    thin: true
  }, children);
};
CouponSettingsSelector.CouponSettingsButtons = CouponSettingsSelectorButtons;

 })(window);